"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _carbonCalculator = require("@/api/query/carbonCalculator");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'carbonCalculator',
  data: function data() {
    return {
      isCnLang: false,
      form: {
        serviceLineId: '',
        pol: undefined,
        pod: undefined,
        volume: 1,
        unit: ''
      },
      carbonInfo: [],
      lineList: [],
      portList: [],
      isResult: false,
      loading: null,
      rules: {
        serviceLineId: [{
          required: true,
          message: this.$t('carbonCalculator.serviceLineIdIsNull'),
          trigger: 'blur'
        }],
        pol: [{
          required: true,
          message: this.$t('validate.pol'),
          trigger: 'blur'
        }],
        pod: [{
          required: true,
          message: this.$t('validate.pod'),
          trigger: 'blur'
        }],
        volume: [{
          required: true,
          message: this.$t('carbonCalculator.volumeIsNull'),
          trigger: 'blur'
        }],
        unit: [{
          required: true,
          message: this.$t('carbonCalculator.unitIsNull'),
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    unique: function unique(arr) {
      var res = new Map();
      return arr.filter(function (arr) {
        return !res.has(arr.portCode) && res.set(arr.portCode, 1);
      });
    },
    reset: function reset(form) {
      this.$refs.form.resetFields();
      this.isResult = false;
    },
    /**
     * 获取航线
     */
    getLineServiceList: function getLineServiceList() {
      var _this = this;
      (0, _carbonCalculator.getLineList)().then(function (response) {
        _this.lineList = response.data;
      });
    },
    /**
     * 选择航线的时候，获取航线对应下的港口
     */
    getPortList: function getPortList(id) {
      var _this2 = this;
      this.form.pol = '';
      this.form.pod = '';
      (0, _carbonCalculator.getLinePortList)({
        serviceLineId: id
      }).then(function (response) {
        _this2.portList = _this2.unique(response.data);
      });
    },
    toSearch: function toSearch() {
      var _this3 = this;
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this3.loading = (0, _utils.load)();
          (0, _carbonCalculator.getCarbonEmmision)(_this3.form).then(function (response) {
            _this3.carbonInfo = response.data;
            _this3.isResult = true;
          }).catch(function () {}).finally(function () {
            _this3.loading.close();
          });
        }
      });
    }
  },
  created: function created() {
    this.isCnLang = this.$i18n.locale === 'zh';
    this.getLineServiceList();
  }
};